<template>
	<div class="content">
		<div v-if="isPdfLoading" class="pdf-loading-overlay">
			<div class="pdf-loading-spinner">
				<div class="pdf-loading-text">{{ pdfLoadingMsg || 'PDF 생성 중...' }}</div>
				<div v-if="pdfLoadingTotal > 0" class="pdf-loading-bar-wrap">
					<div class="pdf-loading-bar" :style="{ width: (pdfLoadingCurrent / pdfLoadingTotal * 100) + '%' }"></div>
				</div>
			</div>
		</div>
		<div v-if="item" class="print-wrap">
			<div class="print-left">
				<!-- <select class="form-control select sm mb-3">
					<option>물건</option>
				</select> -->
				<div class="section-tit">슬라이드 선택/제외</div>
				<div class="table-wrap">
					<table class="table">
						<tr>
							<th>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opAll" @change="setAllCheck" />
									<span class="checkbox"></span>
								</label>
							</th>
							<th>구분</th>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[0]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>INTRO</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[1]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>물건개요</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[2]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>임대정보</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[3]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>건축물정보</td>
						</tr>
						<tr><td><label class="input-checkbox"><input type="checkbox" v-model="invShow" @change="onInvestmentToggle" /><span class="checkbox"></span></label></td><td>투자분석</td></tr>
						<tr><td><label class="input-checkbox"><input type="checkbox" v-model="devShow" @change="onInvestmentToggle" /><span class="checkbox"></span></label></td><td>리모델링/신축</td></tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[4]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>건축 내/외부 사진</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[5]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>지도</td>
						</tr>
					</table>
				</div>
				<div class="section-tit mt-4">사진 선택/제외</div>
				<ul class="table-list">
					<li class="table-list--item" v-for="(op, idx) in item.imgObjList" :key="'opp_' + idx">
						<div class="check">
							<label class="input-checkbox">
								<input type="checkbox" v-model="op.st" @change="updateId" :disabled="!opList[4]" />
								<span class="checkbox"></span>
							</label>
						</div>
						<div class="name">{{ op.name }}</div>
					</li>
				</ul>
				<InvestmentSidebarEditor :state="invState" :residential="invResidential" :can-save="isManager" :save-status="defaultsStatus" @change="onInvestmentEdit" @save="saveInvestmentDefaults" @reset="resetInvestmentDefaults" />
				<SlideEditor :slides="slides" :uploading="slideUploading" @change="onSlideChange" @add-photo="addPhotoSlide" @add-blank="addBlankSlide" />
				<!-- <img :src="this.img" /> -->
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" @click="copyChartImg">출력</button>
				</div>
			</div>
			<div class="print-right" :style="watermarkStyle">
				<!-- 1. 인트로 -->
				<div v-if="opList[0]" id="capture_1" name="capture" class="print-section cover" :class="cobrandClass">
					<div class="tit">
						<!-- <div class="top">Information Memorandum</div> -->
						<div class="middle">{{ item.building_name }}</div>
						<!-- <input type="text" class="text-center middle" value="(C)방이동 삼정빌딩" /> -->
						<div class="bottom">{{ coverAddr }}</div>
					</div>
					<div class="logo"></div>
					<!-- <ol class="list">
						<li v-for="(i, idx) in indexList" :key="'index__' + idx" class="list-item">
							<span class="num">{{ i.idx }}</span> {{ i.name }}
						</li>
					</ol>
					<div class="bottom-text">
						본 Teaser는 WE'ONUS 가 제공하는 자료입니다.<br />
						본 Teaser는 자산의 계략적인 정보, 위치 등을 포함하고 있습니다.<br />
						본 건과 관련하여 궁금하신 사항이 있으실 경우에는<br />
						담당자에게 연락 부탁드립니다.
					</div> -->
				</div>
				<!-- 2. 물건개요 -->
				<div v-if="opList[1]" id="capture_2" name="capture" class="print-section flex1-2">
					<div class="print-tit">OVERVIEW(개요)</div>
					<div class="left">
						<div class="img-wrap"><img :src="item.img" alt="" style="width: 369px; height: 455px" /></div>
						<div class="map-wrap" id="map_0"></div>
					</div>
					<div class="right">
						<div class="section-tit section-tit--print-header" style="margin-bottom: 5px;">물건명 및 주소</div>
						<div class="sub" style="font-size: 20px; font-weight: 600; margin-bottom: 5px;">{{ item.building_name }}</div>
						<div class="sub-addr">{{ bodyAddr }}</div>
						<div class="flex">
							<div>
								<div class="section-tit section-tit--print-header">임대정보</div>
								<div class="table-wrap">
									<table class="table type-input text-left">
										<colgroup>
											<col width="20%" />
											<col width="30%" />
											<col width="20%" />
											<col width="30%" />
										</colgroup>
										<tr>
											<th style="font-weight: 700;">주소</th>
											<td colspan="3" style="font-weight: 700;">{{ bodyAddr }}</td>
										</tr>
										<tr>
											<th>보증금</th>
											<td colspan="3" class="txt-c--red">{{ $formatMoney(item.deposit, $MONEY_FORMAT_TYPE.LOAN) }}</td>
										</tr>
										<tr>
											<th>월세</th>
											<td colspan="3" class="txt-c--red">
												{{ $formatMoney(item.monthly_rent, $MONEY_FORMAT_TYPE.LOAN) }}
											</td>
										</tr>
										<tr>
											<th>관리비</th>
											<td colspan="3">{{ $formatMoney(item.main_fee, $MONEY_FORMAT_TYPE.LOAN) }}</td>
										</tr>
										<tr>
											<th>관리비 지출·수익</th>
											<td colspan="3">{{ item.ex_sum_mgr_fee_out ? $formatMoney(item.ex_sum_mgr_fee_out, $MONEY_FORMAT_TYPE.LOAN) : '-' }} / {{ (item.ex_sum_mgr_fee && item.ex_sum_mgr_fee_out) ? $formatMoney(item.ex_sum_mgr_fee - item.ex_sum_mgr_fee_out, $MONEY_FORMAT_TYPE.LOAN) : '-' }}</td>
										</tr>
										<tr>
											<th>월고정비</th>
											<td colspan="3" class="txt-c--red">
												{{ $formatMoney(item.monthly_fixed, $MONEY_FORMAT_TYPE.LOAN) }}
											</td>
										</tr>
										<tr>
											<th>전용면적</th>
											<td class="txt-c--red">{{ $formatArea(item.net_area_py) }}평</td>
											<th>전용률</th>
											<td>{{ item.ex_rate }}%</td>
										</tr>
										<tr>
											<th>임대면적</th>
											<td colspan="3">{{ $formatArea(item.rent_area_py) }}평</td>
										</tr>
										<tr>
											<th>평당임대료</th>
											<td colspan="3" class="txt-c--red">
												{{ $formatMoney(item.rent_py_price, $MONEY_FORMAT_TYPE.LOAN) }}
											</td>
										</tr>
										<tr>
											<th>층정보</th>
											<td>{{ item.floor_info }}</td>
											<th>입주현황</th>
											<td>{{ item.in_status }}</td>
										</tr>
										<tr>
											<th>무료 주차대수</th>
											<td>{{ item.free_parking }}</td>
											<th>유료 주차대수</th>
											<td>{{ item.fee_paring }}</td>
										</tr>
										<tr>
											<th>화장실 유형</th>
											<td colspan="3">{{ item.bathroom_type }}</td>
										</tr>
										<tr>
											<th>인테리어</th>
											<td colspan="3">{{ $INTERIOR_TYPE[item.interior_type] }}</td>
										</tr>
										<tr>
											<th>렌트프리</th>
											<td colspan="3">
												<template v-if="item.rent_free == 'selet'"> {{ item.rent_free_month }}개월 </template>
												<template v-else>{{ $RENT_FREE[item.rent_free] }}</template>
											</td>
										</tr>
									</table>
								</div>
							</div>
							<div>
								<div class="section-tit section-tit--print-header">토지정보</div>
								<div class="table-wrap">
									<table class="table type-input text-left">
										<colgroup>
											<col width="50%" />
											<col width="50%" />
										</colgroup>
										<tr>
											<th class="txt-c--red">주변역</th>
											<td class="txt-c--red">{{ item.substation }}</td>
										</tr>
										<tr>
											<th class="txt-c--red">거리</th>
											<td class="txt-c--red">{{ item.substation_distance ? item.substation_distance + 'm' : '' }}</td>
										</tr>
										<tr>
											<th>대지면적</th>
											<td>{{ $formatArea(item.land_size_m2) }}㎡ [{{ $formatArea(item.land_size_p) }}평]</td>
										</tr>
										<tr>
											<th>용도지역</th>
											<td>{{ item.cfg_val1 }}</td>
										</tr>
										<tr>
											<th>공시지가</th>
											<td>{{ $formatMoney(item.public_land_price, $MONEY_FORMAT_TYPE.LOAN) }}</td>
										</tr>
										<tr>
											<th>도로사항</th>
											<td>
												<template v-if="item.roadwide_1">{{ item.roadwide_1 }}m</template>
												<template v-if="item.roadwide_2">,{{ item.roadwide_2 }}m</template>
												<template v-if="item.roadwide_3">,{{ item.roadwide_3 }}m</template>
												<template v-if="item.roadwide_4">,{{ item.roadwide_4 }}m</template>
												<template v-if="item.chk_road_coner == 'Y'">,코너</template>
												<template v-if="item.chk_road_dual == 'Y'">,양면</template>
												&nbsp;
												<template v-if="item.road_name">[{{ item.road_name }}]</template>
											</td>
										</tr>
									</table>
								</div>
								<div class="section-tit section-tit--print-header mt-4">건축물정보</div>
								<div class="table-wrap">
									<table class="table type-input text-left">
										<colgroup>
											<col width="50%" />
											<col width="50%" />
										</colgroup>
										<tr>
											<th>준공연도/리모델링</th>
											<td>
												{{ $dateFormat(item.build_date) }}
												{{ item.remodel_date ? '/ ' + $dateFormat(item.remodel_date) : '' }}
											</td>
										</tr>
										<tr>
											<th class="txt-c--red">승강기</th>
											<td class="txt-c--red">{{ item.ev_cnt ? item.ev_cnt + '대' : '' }}</td>
										</tr>
										<tr>
											<th>냉/난방식</th>
											<td>{{ item.heat_type_name }}</td>
										</tr>
										<tr>
											<th>규모</th>
											<td>
												{{ $getFloorString(item.floor_cnt_B, item.floor_cnt_F) }}
											</td>
										</tr>
										<tr>
											<th>건폐율/용적률</th>
											<td>{{ $formatRatio(item.bl_ratio) }}/{{ $formatRatio(item.fa_ratio) }}</td>
										</tr>
										<tr>
											<th>주차방식/대수</th>
											<td>
												<template v-if="item.park_type_name">{{ item.park_type_name }} /</template>
												법정 {{ item.park_cnt_law }}대 / 실제 {{ item.park_cnt_real }}대
											</td>
										</tr>
										<tr>
											<th>연면적</th>
											<td colspan="3">{{ $formatArea(item.total_size_m2) }}㎡ [{{ $formatArea(item.total_size_p) }}평]</td>
										</tr>
										<tr>
											<th>건축면적</th>
											<td colspan="3">{{ $formatArea(item.build_size_m2) }}㎡ [{{ $formatArea(item.build_size_p) }}평]</td>
										</tr>
									</table>
								</div>
							</div>
						</div>
						<div class="section-tit mt-4">특징</div>
						<ul class="dot-list box-line">
							<div v-html="item.memo.split('\n').join('<br />')"></div>
						</ul>
					</div>
				</div>
				<!-- 3. 임대정보 -->
				<div v-if="opList[2]" id="capture_3" name="capture" class="print-section">
					<div class="print-tit">STACKING PLAN</div>
					<div class="table-wrap">
						<table class="table sm">
							<thead>
								<tr>
									<th>층</th>
									<th>임대면적(㎡)</th>
									<th>임대면적(평)</th>
									<th>용도</th>
									<th>보증금</th>
									<th>월세</th>
									<th>관리비</th>
									<th>만기</th>
									<th>비고</th>
								</tr>
							</thead>
							<tbody>
								<tr :key="'rent_' + rent.building_rent_uid" v-for="rent in rentList" :class="{ 'rent-excluded': rent.except_flag === 'Y' }">
									<th>{{ rent.rent_floor }}</th>
									<td>{{ $formatArea(rent.rent_size_m2) }}</td>
									<td>{{ $formatArea(rent.rent_size_p) }}</td>
									<td>{{ rent.rent_usage }}</td>
									<td>{{ $formatNumber(rent.rent_deposit) }}</td>
									<td>{{ $formatNumber(rent.rent_money) }}</td>
									<td>{{ rent.mgr_fee ? $formatNumber(rent.mgr_fee) : 0 }}</td>
									<td>{{ rent.end_date }}</td>
									<td>{{ rent.memo }}</td>
								</tr>
								<tr>
									<th class="bg-blue">합계</th>
									<td class="bg-blue">{{ $formatNumber(totalData.m2) }}</td>
									<td class="bg-blue">{{ $formatNumber(totalData.py) }}</td>
									<td class="bg-blue"></td>
									<td class="bg-blue">{{ $formatNumber(totalData.deposit) }}</td>
									<td class="bg-blue">{{ $formatNumber(totalData.money) }}</td>
									<td class="bg-blue">{{ $formatNumber(totalData.mgr) }}</td>
									<td class="bg-blue"></td>
									<td class="bg-blue"></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="table-text">※ 임대차계약서 상 임대면적의 총합과 건축물대장 상 연면적이 다소 차이가 있음</div>
				</div>
				<!-- 4. 건축물정보 -->
				<div v-if="opList[3]" id="capture_4" name="capture" class="print-section">
					<div class="print-tit">BUILDING REGISTER</div>
					<div class="table-wrap">
						<table class="table sm">
							<thead>
								<tr>
									<th>층</th>
									<th>면적(㎡)</th>
									<th>평수</th>
									<th>층별용도</th>
								</tr>
							</thead>
							<tbody>
								<tr :key="'floor_' + floor.building_floor_uid" v-for="floor in floorList" :class="{ 'floor-excluded': floor.chk_except === 'Y' }">
									<td>{{ floor.flrNoNm }}</td>
									<td>{{ $formatArea(floor.area_m2) }}</td>
									<td>{{ $formatArea(floor.area_py) }}</td>
									<td>{{ floor.name }}</td>
								</tr>
								<tr>
									<td class="bg-blue">합계</td>
									<td class="bg-blue">{{ totalFloorData.m2 }}</td>
									<td class="bg-blue">{{ totalFloorData.py }}</td>
									<td class="bg-blue"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<InvestmentAnalysisPage v-if="invShow && invAcq" :acq="invAcq" :tax-rate="invState.taxRate" :broker-rate="invState.brokerRate" :ltv="invState.ltv" :loan-rate="invState.loanRate" :noi="invState.noi" :residential="invResidential" />
				<DevelopmentPlanPage v-if="devShow && invDev && invFunding" :dev="invDev" :funding="invFunding" />

				<!-- 5. 건물 내/외부 (사진 여러개)-->
				<template v-if="opList[4]">
					<div
						v-for="(pic, idx) in item.imgObj"
						:id="'picture_' + idx"
						:key="'picture_' + idx"
						class="print-section flex"
						name="capture"
					>
						<div class="print-tit">PHOTO</div>
						<template v-for="(i, ii) in pic" :key="idx + '_' + ii + '_' + 'pic'">
							<div v-if="(ii = 0)" class="left">
								<div class="section-tit">{{ i.name }}</div>
								<div class="img-wrap">
									<img :src="i.img" alt="" style="width: 540px; height: 650px" />
								</div>
							</div>
							<div v-else class="right">
								<div class="section-tit">{{ i.name }}</div>
								<div class="img-wrap">
									<img :src="i.img" alt="" style="width: 540px; height: 650px" />
								</div>
							</div>
						</template>
					</div>
				</template>
				<!-- 6. 지도 -->
				<div v-show="opList[5]" id="capture_5" name="capture" class="print-section flex">
					<div class="left">
						<div class="print-tit">MAP</div>
						<div id="map_1"></div>
					</div>
					<div class="right">
						<div class="print-tit">MAP</div>
						<div id="map_2"></div>
					</div>
				</div>

				<!-- #7 부록 슬라이드(맨 뒤, end 표지 직전) -->
				<SlidePage v-for="s in slides" :key="'slide_' + s.id" :id="'slide_' + s.id" name="capture" :slide="s" />
				<!-- 7. end -->
				<div name="capture" id="capture_99" class="print-section cover end">
					<ul class="info" :class="cobrandClass">
						<li class="info-item name">
							<span class="text">
								<strong>{{ userInfo.mem_name }}</strong> {{ userInfo.mem_rank_name }}
							</span>
						</li>
						<li class="info-item">
							<label class="label">M.</label>
							<span class="text">{{ userInfo.mem_mobile }}</span>
						</li>
						<li class="info-item">
							<label class="label">T.</label>
							<span class="text">02-6956-2791</span>
						</li>
						<li class="info-item">
							<label class="label">E.</label>
							<span class="text">{{ userInfo.mem_email }}</span>
						</li>
						<li class="info-item">
							<label class="label">F.</label>
							<span class="text">{{ userInfo.mem_fax || '070-4693-5728' }}</span>
						</li>
						<li class="info-item">
							<span class="text">서울특별시 강남구 학동로25길 11, 5층 (논현동, 씨플레이스)</span>
						</li>
					</ul>
					<!-- 신한/대신 제휴 게스트 PDF: 위온어스 중개법인 Contact Point 배너(첨부 디자인) 항상 표기 -->
					<div class="broker-corp" v-if="cobrandClass">
						<div class="bc-title">Contact Point</div>
						<div class="bc-corp"><strong>위온어스부동산중개법인</strong><span class="bc-addr"> (서울특별시 강남구 학동로25길 11, 5층(논현동, 씨플레이스))</span></div>
						<div class="bc-col bc-col1">
							<div class="bc-name">서치원 대표</div>
							<div class="bc-tel">+82 010-5566-4948</div>
						</div>
					</div>
					<div class="bottom-text">
						본 Teaser는 본 건 투자를 위한 기본적인 정보를 제공할 목적으로 작성되었습니다. Teaser의 세부적인 내용은 추후
						진행사항에 따라 수정되거나 변경될 수 있고, WEONUS 는 내용에 대해 어떠한 책임도 부담하지 않습니다.<br />
						또한 Teaser에서 제공한 정보는 어떠한 제약의 근거로 사용될 수 없습니다. Teaser의 어떠한 부분도 매도자 및
						WEONUS의 사전 동의 없이 외부에 복사, 인용, 재배포 및 유통될 수 없습니다.
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { normalizeAddr, formatBodyAddr } from '@/utils/format';
import InvestmentAnalysisPage from '@/components/print/InvestmentAnalysisPage.vue';
import DevelopmentPlanPage from '@/components/print/DevelopmentPlanPage.vue';
import InvestmentSidebarEditor from '@/components/print/InvestmentSidebarEditor.vue';
import SlidePage from '@/components/print/SlidePage.vue';
import SlideEditor from '@/components/print/SlideEditor.vue';
import investmentProposal from '@/mixins/investmentProposal';
import { startPrintPage, markStage, markReady, markFailed } from '@/utils/printStatus.mjs';

export default {
	name: 'PrintPage',
	printBuildingType: 'rent',
	mixins: [investmentProposal],
	invPagesDefaultOff: true,
	components: {
		InvestmentAnalysisPage,
		DevelopmentPlanPage,
		InvestmentSidebarEditor,
		SlidePage,
		SlideEditor,
	},
	data() {
		return {
			bid: null,

			map: null,
			marker: null,

			map_1: null,
			marker_1: null,

			map_2: null,
			marker_2: null,
			mapType: null,

			indexList: [],
			capIdList: [],
			isPdfLoading: false,
			// F-5.1: progress indicator state for $exportPrint
			pdfLoadingMsg: '',
			pdfLoadingCurrent: 0,
			pdfLoadingTotal: 0,

			opAll: true,
			opList: [true, true, true, true, true, true],

			item: null,
			rentList: [],
			floorList: [],
			totalData: {
				m2: 0,
				py: 0,
				deposit: 0,
				money: 0,
				mgr: 0,
			},

			totalFloorData: {
				m2: 0,
				py: 0,
			},

			rentRate: {
				labels: ['임대율'],
				datasets: [
					{
						label: '임대율',
						data: [0],
						backgroundColor: '#f87979',
					},
				],
			},
			rentRateSt: false,
			rentRateList: {
				labels: ['임대'],
				datasets: [],
			},
			rentRateListSt: false,

			coverAddr: '',
			bodyAddr: '',

			userInfo: {},
		};
	},
	computed: {
		// 페이지 워터마크 'weonus' 아래줄에 출력자(로그인 사용자) 이름 표기.
		watermarkStyle() {
			const name = (this.userInfo && this.userInfo.mem_name) || '';
			return name ? { '--print-watermark-name': `'${name.replace(/'/g, '')}'` } : {};
		},
		// 제휴 게스트(은행직원) 세션에서만 — 마지막 페이지 위온어스 × 기관 공동로고.
		cobrandClass() {
			if (!this.$store.getters.getGuest) return null;
			const inst = this.$store.getters.getInstitution;
			return inst === 'shinhan' || inst === 'daishin' ? inst : null;
		},
	},
	created() {
		this.bid = this.$route.query.bid;

		// 지도 전용 출력 페이지(Panorama 미사용): base SDK(naver.maps.Map) 준비만 기다린다.
		// 'core' 로 호출해 panorama 서브모듈 지연/실패가 지도·PDF 렌더를 막지 않게 한다.
		this.mapScriptReady = this.$loadNaverMaps('core');

		startPrintPage();
		try {
			this.init();
		} catch (e) {
			// init 이 동기 예외로 끊기면 서버가 30초를 기다리게 두지 않는다.
			console.warn('init aborted:', e);
			markFailed('init aborted: ' + ((e && e.message) || e));
		}
	},
	methods: {
		init() {
			this.getItem();
			this.getRent();
			this.getFloor();
			this.getUser();
		},
		getUser() {
			this.$apiGET('/admin/api/user/info').then(re => {
				this.userInfo = re;
				// if (re) {
				// 	this.$store.dispatch('callSetUserInfo', re);
				// }
			});
		},
		loadMap() {
			// Bug AR (2026-05-11): PrintPage.vue 와 동일 패턴 — mapScriptReady race
			// 에서 컨테이너 부재시 throw 방지. 화면/PDF 영향 없음.
			if (!this.item || !this.item.pt) return;
			if (!document.getElementById('map_0')
				|| !document.getElementById('map_1')
				|| !document.getElementById('map_2')) return;

			this.map = new window.naver.maps.Map('map_0', {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 16,
			});
			this.map.setCenter({ lat: this.item.pt.y, lng: this.item.pt.x });
			// this.map.setSize({ width: '369px', height: '270px' });
			this.marker = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
				map: this.map,
			});

			this.map_1 = new window.naver.maps.Map('map_1', {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 16,
			});
			this.map_1.setCenter({ lat: this.item.pt.y, lng: this.item.pt.x });
			this.map_1.setSize({ width: '550px', height: '690px' });
			this.marker_1 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
				map: this.map_1,
			});

			this.mapType = new window.naver.maps.CadastralLayer();

			this.map_2 = new window.naver.maps.Map('map_2', {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 18,
			});

			this.mapType.setMap(this.map_2);

			this.map_2.setCenter({ lat: this.item.pt.y, lng: this.item.pt.x });
			this.map_2.setSize({ width: '550px', height: '690px' });
			this.marker_2 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
				map: this.map_2,
			});
		},
		async copyChartImg() {
			this.isPdfLoading = true;
			this.pdfLoadingMsg = '출력 준비 중...';
			this.pdfLoadingCurrent = 0;
			this.pdfLoadingTotal = 0;
			// F-5.1: progress callback passed to $exportPrint
			const onProgress = (current, total) => {
				this.pdfLoadingTotal = total;
				this.pdfLoadingCurrent = current;
				this.pdfLoadingMsg = total > 1
					? `출력 준비 중... (${current}/${total} 페이지)`
					: '출력 준비 중...';
			};
			try {
				this.$apiPOST('/admin/api/detail/item/print2', { bidList: [this.bid] }).then(() => {});
				try {
					this.syncInvestmentToUrl(); // 편집 투자분석 입력값을 URL 에 반영(서버 PDF 재로드 대비)
					this.rebuildCapIdList(); // ③④ 토글 후 capIdList 최신화(stale 셀렉터 hang 방지)
					await this.$exportPdf(this.capIdList, this.item.building_name);
				} catch (e) {
					console.warn('Server PDF failed, falling back to client-side:', e);
					await this.$exportPrint(this.capIdList, onProgress, this.item.building_name);
				}
			} finally {
				this.isPdfLoading = false;
				this.pdfLoadingMsg = '';
			}
		},
		// 보이는(offsetParent!==null) + id 있는 capture 섹션만 수집한다.
		// 지도는 v-show 라 체크 해제해도 display:none 으로 DOM 에 잔존하는데, 이를 capIdList 에 담으면
		// 서버 PDF 가 그 섹션을 빈/거대 페이지로 렌더해 전체가 축소되고 빈 페이지가 늘어난다. 그래서 필터링.
		collectCaptureIds() {
			const ids = [];
			const nodes = document.getElementsByName('capture');
			for (let i = 0; i < nodes.length; i++) {
				const el = nodes[i];
				if (el.id && el.offsetParent !== null) ids.push(el.id);
			}
			return ids;
		},
		rebuildCapIdList() {
			markStage('dom-rendered');
			this.capIdList = this.collectCaptureIds();
		},
		getItem() {
			markStage('item-loading');
			this.$apiGET('/admin/api/detail/item?bid=' + this.bid + '&isRent=true').then(async data => {
				// Bug AF: 백엔드가 row 미존재 시 res.send(false) → data === false.
				// Bug Z-2 contract: PDF headless 백엔드는 __VUE_PRINT_STATUS__ 를 polling 하므로
				// terminal 상태 ('ready'/'failed') 미세팅 시 30s 까지 hang 후 timeout 500. fail-fast
				// 위해 reason → status 순서로 세팅 (backend 가 status='failed' 본 직후 reason read).
				if (!data || typeof data !== 'object') {
					markFailed('detail/item returned no row for bid=' + this.bid);
					alert('해당 매물 정보를 찾을 수 없습니다.');
					return;
				}
				markStage('item-loaded');
				for (let prop in data) {
					if (data[prop] == null) {
						data[prop] = '';
					}
				}

				data.img = null;

				//썸네일
				for (let i = 0; i < data.imgList.length; i++) {
					if (data.imgList[i]) {
						data.img = process.env.VUE_APP_HOST_BACK + '/users/item/image2?id=' + data.imgList[i] + '&w=1200&q=82';
						break;
					}
				}

				//이미지 리스트
				let imgObjList = [];
				for (let i = 0; i < data.imgList.length; i++) {
					if (data.imgList[i]) {
						imgObjList.push({
							// I1: 사용자 라벨 우선, fallback IMG_NAME.
							name: (data.imgLabels && data.imgLabels[i] && data.imgLabels[i].length) ? data.imgLabels[i] : this.$IMG_NAME[i],
							img: process.env.VUE_APP_HOST_BACK + '/users/item/image2?id=' + data.imgList[i] + '&w=1200&q=82',
							st: true,
						});
					}
				}
				data.imgObjList = imgObjList;

				let imgObj = [];
				for (let i = 0; i < imgObjList.length; i += 2) {
					imgObj.push(imgObjList.slice(i, i + 2));
				}

				data.imgObj = imgObj;

				// F-5.2: set fallback addresses from building data, then fetch land parcels.
				// this.item is assigned only after getLand() resolves so the print UI
				// never renders with stale coverAddr / bodyAddr.
				// F-2.1: legacy row 방어선 — 원시 주소도 정규화 후 세팅.
				const fallbackAddr = normalizeAddr(data.jibun_addr);
				this.coverAddr = fallbackAddr;
				this.bodyAddr = fallbackAddr;
				try { await this.getLand(); } catch(e) { /* fallback already set */ }

				this.item = data;

				this.$nextTick(() => {
					markStage('dom-rendered');
					this.capIdList = this.collectCaptureIds();
					markReady();
				});

				this.indexList = [];
				let idx = 1;
				for (let i = 1; i < this.opList.length; i++) {
					if (this.opList[i]) {
						if (i == 1) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '물건개요',
							});
						} else if (i == 2) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '임대정보',
							});
						} else if (i == 3) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '건축물정보',
							});
						} else if (i == 4) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '건축 내/외부 사진',
							});
						} else if (i == 5) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '지도',
							});
						}
						idx++;
					}
				}

				this.mapScriptReady
					.then(() => {
						this.$nextTick(() => { this.loadMap(); });
					})
					.catch(e => { console.warn('Naver Maps script failed:', e); });
			});
		},
		updateId() {
			let data = JSON.parse(JSON.stringify(this.item));

			//이미지 리스트
			let imgObjList = [];
			for (let i = 0; i < data.imgObjList.length; i++) {
				if (data.imgObjList[i].st) {
					imgObjList.push(data.imgObjList[i]);
				}
			}

			let imgObj = [];
			for (let i = 0; i < imgObjList.length; i += 2) {
				imgObj.push(imgObjList.slice(i, i + 2));
			}

			this.item.imgObj = imgObj;

			this.$nextTick(() => {
				markStage('dom-rendered');
				this.capIdList = this.collectCaptureIds();
			});

			this.indexList = [];
			let idx = 1;
			for (let i = 1; i < this.opList.length; i++) {
				if (this.opList[i]) {
					if (i == 1) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '물건개요',
						});
					} else if (i == 2) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '임대정보',
						});
					} else if (i == 3) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '건축물정보',
						});
					} else if (i == 4) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '건축 내/외부 사진',
						});
					} else if (i == 5) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '지도',
						});
					}
					idx++;
				}
			}
		},
		getRent() {
			this.$apiGET('/admin/api/detail/item/rent2?bid=' + this.bid).then(data => {
				this.rentList = data;
				let m2 = 0;
				let py = 0;
				let deposit = 0;
				let money = 0;
				let mgr = 0;

				let cnt = data.length;
				let sumCnt = 0;

				for (let i = 0; i < this.rentList.length; i++) {
					if (data[i].rent_money) {
						sumCnt++;
					}

					// 면적은 항상 합산 (F-3.4)
					m2 += Number(this.rentList[i].rent_size_m2);
					py += Number(this.rentList[i].rent_size_p);
					if (this.rentList[i].except_flag != 'Y') {
						deposit += Number(this.rentList[i].rent_deposit);
						money += Number(this.rentList[i].rent_money);
						mgr += Number(this.rentList[i].mgr_fee);
					}
				}

				if (cnt) {
					this.rentRate.datasets[0].data[0] = Number(((sumCnt / cnt) * 10 * 10).toFixed(2));
				} else {
					this.rentRate.datasets[0].data[0] = 0;
				}

				const rentGroup = this.$groupBy(data, 'rent_usage');
				for (let prop in rentGroup) {
					const curCnt = rentGroup[prop].length;
					this.rentRateList.datasets.push({
						label: prop,
						data: [Number(((curCnt / cnt) * 100).toFixed(2))],
					});
				}

				this.rentRateSt = true;
				this.rentRateListSt = true;

				this.totalData.m2 = m2.toFixed(2);
				this.totalData.py = py.toFixed(2);
				this.totalData.deposit = deposit;
				this.totalData.money = money;
				this.totalData.mgr = mgr;
			});
		},
		getFloor() {
			this.$apiGET('/admin/api/detail/item/floor2?bid=' + this.bid).then(data => {
				this.floorList = data;
				let m2 = 0;
				let py = 0;

				for (let i = 0; i < this.floorList.length; i++) {
					// 건축물대장이 면적 제외로 표시한 행(옥탑 계단실 등)은 연면적에 들지 않는다(DD). 담당자 제외 체크와는 별개다.
					if (String(this.floorList[i].areaExctYn) === '1') continue;
					m2 += Number(this.floorList[i].area_m2);
					py += Number(this.floorList[i].area_py);
				}

				this.totalFloorData.m2 = m2.toFixed(2);
				this.totalFloorData.py = py.toFixed(2);
			});
		},
		getLand() {
			return this.$apiGET('/admin/api/detail/item/edit/land2?bid=' + this.bid).then(data => {
				// F-2.1: legacy row 방어선 — 렌더 직전에 "서울특별시 … 번지" 정규화.
				// F-2.3: dedup (동일 주소 반복 방지).
				const uniqueAddrs = [...new Set(
					data.map(d => normalizeAddr(d.jibun_addr)).filter(Boolean)
				)];
				if (uniqueAddrs.length > 1) {
					this.coverAddr = uniqueAddrs[0] + ' 외 ' + (uniqueAddrs.length - 1) + '필지';
				} else if (uniqueAddrs.length === 1) {
					this.coverAddr = uniqueAddrs[0];
				}
				// F-5.2: 본문은 시/구 제거 + 동일 동 반복 생략 포맷.
				this.bodyAddr = formatBodyAddr(uniqueAddrs) || this.coverAddr;
			});
		},
		setAllCheck() {
			for (let i = 0; i < this.opList.length; i++) {
				this.opList[i] = this.opAll;
			}
			this.updateId();
		},
	},
};
</script>

<style lang="scss" scoped>
// F-5.5 print layout red theme
.section-tit--print-header {
	background-color: #a23334;
	color: #fff !important;
	border-color: #a23334 !important;
	padding: 6px 10px;
	border-radius: 2px;
}

// F-3.5 제외 row 연회색 처리 스타일은 assets/css/common.scss 로 이동 (전역 단일 정의).
.pdf-loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}
.pdf-loading-spinner {
	background: white;
	padding: 30px 50px;
	border-radius: 8px;
	font-size: 18px;
	font-weight: bold;
	min-width: 260px;
	text-align: center;
}
.pdf-loading-text {
	margin-bottom: 14px;
}
.pdf-loading-bar-wrap {
	width: 100%;
	height: 8px;
	background: #e0e0e0;
	border-radius: 4px;
	overflow: hidden;
}
.pdf-loading-bar {
	height: 100%;
	background: #1976d2;
	border-radius: 4px;
	transition: width 0.25s ease;
}
</style>
